import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import './index.css'
import UtilityNav from '../../../_components/common/UtilityNav';
import TableNew from '../../../_components/common/Table';
import ModalComponent from '../../../_components/common/Modal';
import { addPaUsersFd } from './formData';
import tableSort from '../../../_components/common/Sort';
import { orgAdminAction } from '../../../_actions';
import { headerPermissionAction } from '../../../_actions/Analyze/headerPermission.action';

class PaUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            paUserDetails: null,
            addPaUsers: false,
            RemovePaUser: false,
            sortType: false,
            orgId: null,
            updateModalState: false,
            updateMessage: null,
            navData: [],

            tableData: [
            ]
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.setState({
            orgId: +this.props.match.params.id
        })

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        this.props.dispatch(orgAdminAction.getOrgUsersHandler(+this.props.match.params.id, () => { }))
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)

    }


    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.props.getOrgUsersResponse
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ tableData: arrayCopy });
    }

    toggleAddPaUsersModal(showModal) {
        this.setState({
            addPaUsers: showModal,
        })
        addPaUsersFd.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    toggleDeletePaUsersModal = (showModal) => {
        this.setState({
            addPaUsers: false,
            RemovePaUser: true,
            paUserDetails: showModal
        })
    }

    actionSelectedAddPaUsers = (data) => {
        // let removeSpaceFromData = data.data.email_Id.replace(/ /g, '')
        // let splitData = removeSpaceFromData.split(',')
        const fd = {
            "organisation_id": this.state.orgId,
            'pa_user_email': data.data.email
        }
        this.props.dispatch(orgAdminAction.addPaUsersHandler(fd, (response) => {
            this.setState({
                deleteOrgModal: false,
                updateMessage: {
                    status: response.status,
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">${response.status === 200 ? 'Success!' : 'Error!'}</p>
                    <p>${response.data.message}</p>
                </div>`,
                    heading: 'Add PA Users',
                    headerColor: response.status === 200 ? `` : `bg-danger`,
                    headingIcon: response.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                },
                updateModalState: true
            }, () => {
                this.callHeaderPermissions()
            })
        }))
    }

    updateNavItems = () => {
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    toggleEntirePaUsersModal(showModal) {
        this.setState({
            addPaUsers: showModal,
            RemovePaUser: showModal,
            paUserDetails: showModal
        })
    }

    onClickRemovePaUser = (type) => {
        if (type === 'Remove') {
            const fd = {
                "organisation_id": this.state.orgId,
                'pa_user_email': this.state.paUserDetails.pa_user__email
            }
            this.props.dispatch(orgAdminAction.removePaUsersHandler(fd, (response) => {
                this.setState({
                    deleteOrgModal: false,
                    updateMessage: {
                        status: response.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${response.status === 200 ? 'Success!' : 'Error!'}</p>
                        <p>${response.data.message}</p>
                    </div>`,
                        heading: 'Remove PA Users',
                        headerColor: response.status === 200 ? `` : `bg-danger`,
                        headingIcon: response.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                }, () => {
                    this.callHeaderPermissions()
                })
            }))
        }

        this.setState({
            RemovePaUser: false,
        })
    }

    callHeaderPermissions = () => {
        let id = this.props.match.params.id
        this.props.dispatch(headerPermissionAction.headerPermissionDataAction({"analytics_org_id": id},(callback_data) => {
            if(callback_data.data !== '') {
                localStorage.setItem('is_org_admin',callback_data.data.is_org_admin);
                localStorage.setItem('is_pa_user',callback_data.data.is_pa_user);
                localStorage.setItem('is_success',callback_data.data.is_super_admin);
                this.updateNavItems();
            };
        }));
    }

    render() {
        const { getOrgUsersResponse } = this.props;
        const tables = {
            Team: [{
                name: 'Name',
                key: 'pa_user__email',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: `/organisation/${this.props.match.params.id}/org-admin/PaUsersPermissions/`
            },
            {
                name: 'Email',
                key: 'pa_user__email',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: `/organisation/${this.props.match.params.id}/org-admin/PaUsersPermissions/`
            },
            {
                name: 'Remove',
                key: 'REMOVE/DELETE',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fas fa-times-circle fas-custom',
                alignCenter: true,
                headingAlign: true,
                level: 'team_level',
                title: 'Remove PA User'
                // buttonDisabled: 'buttonDisabled'
            }]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                <div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE PA USERS</h5>

                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Add PA Users',
                                    toggler: this.toggleAddPaUsersModal.bind(this),
                                    togglerModal: this.state.addPaUsers,
                                    icon: 'fa fa-plus',
                                    title: 'Add PA User'
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            getOrgUsersResponse !== '' &&
                            <TableNew
                                data={getOrgUsersResponse}
                                columns={tables.Team}
                                onClickRemoveorDeleteButton={this.toggleDeletePaUsersModal.bind(this)}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {
                            (getOrgUsersResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }


                        {
                            this.state.addPaUsers &&
                            <ModalComponent
                                showModal={this.state.addPaUsers}
                                heading="Add PA Users"
                                formData={addPaUsersFd}
                                // htmlText={'<div className = "ml-1  pl-1 pl-md-3"><p className="">Please enter a list of comma separated email IDs </div>'}
                                action={this.actionSelectedAddPaUsers.bind(this)}
                                toggleEntireModal={this.toggleEntirePaUsersModal.bind(this)}
                                footerFormSubmitButton={['Submit', 'Cancel']}
                            />
                        }
                        {
                            this.state.RemovePaUser &&
                            <ModalComponent
                                showModal={this.state.RemovePaUser}
                                heading="Remove PA User"
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 text-center">
                                <p className="">Are you sure you want to remove the PA user : <br/><b>${this.state.paUserDetails.pa_user__email}</b></p>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickRemovePaUser(type)}
                                toggleEntireModal={this.toggleEntirePaUsersModal.bind(this)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { getOrgUsersLoading } = state.getOrgUsers;
    const getOrgUsersError = state.getOrgUsers.error;
    const getOrgUsersResponse = (!getOrgUsersLoading && !getOrgUsersError) ? state.getOrgUsers.data.data.organisation_PA_users : '';

        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getOrgUsersResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(PaUsers);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/PsUsers.js